// extracted by mini-css-extract-plugin
module.exports = {"langWrapper":"styles_langWrapper__0PI8O","langButton":"styles_langButton__M0PKd","langDropdown":"styles_langDropdown__AAyo8","visible":"styles_visible__ZjhHe"};